import { fileUploadColumn, grandTotalFields, totalsColumn, unitInputColumn, valueInputColumn } from './columns'

function generateSupplierOptions(supplierData) {
    if (supplierData && supplierData.length > 0) {
        return supplierData.map((supplier) => ({ id: supplier.id, value: supplier.name }))
    }
    else {
        return [{ id: 0, value: 'No Suppliers Available' }]
    }

}

// --- Water Columns ---

export const waterColumns = (supplierData) => [
    {
        label: 'Water Source',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Purchased Water' },
        ],
        selectLabel: 'Select Source'
    },
    {
        label: 'Supplier',
        field: 'supplier',
        type: 'select',
        options: generateSupplierOptions(supplierData),
        selectLabel: 'Select Supplier',
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilolitres' },
        ]
    },
    {
        ...valueInputColumn,
    },
    {
        ...fileUploadColumn,
    }
]

// --- Water Totals ---

export const waterTotalColumns = totalsColumn.kilolitres
export const waterGrandTotalFields = grandTotalFields.kilolitres


// --- Chemical Additives Columns ---

export const chemicalsAndAdditivesColumns = (supplierData) => [
    {
        label: 'Chemicals and Additives',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Sulphur Dioxide' },
            { id: 0, value: 'Carbon Dioxide' },
            { id: 0, value: 'Yeast' },
            { id: 0, value: 'Lactic Acid' }
        ],
        selectLabel: 'Select Type'
    },
    {
        label: 'Supplier',
        field: 'supplier',
        type: 'select',
        options: generateSupplierOptions(supplierData),
        selectLabel: 'Select Supplier',
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
            { id: 0, value: 'Litres' },
        ],
        selectLabel: 'Unit',
        disabled: true
    },
    {
        ...valueInputColumn,
    },
    {
        ...fileUploadColumn,
    }
]

// --- Chemical Additives Totals ---

export const chemicalsAndAdditivesTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Sulphur Dioxide (kg)', field: 'sulphurDioxideQuantity' },
    { label: 'Carbon Dioxide (kg)', field: 'carbonDioxideQuantity' },
    { label: 'Yeast (kg)', field: 'yeastQuantity' },
    { label: 'Lactic Acid (L)', field: 'lacticAcidQuantity' },
];

export const chemicalsAndAdditivesGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Sulphur Dioxide (kg)', field: 'grand_total_sulphur_dioxide' },
    { label: 'Grand Total Carbon Dioxide (kg)', field: 'grand_total_carbon_dioxide' },
    { label: 'Grand Total Yeast (kg)', field: 'grand_total_yeast' },
    { label: 'Grand Total (L)', field: 'grand_total_lactic_acid' }
];

// --- Wooden Products Columns ---

export const woodenProductsColumns = (supplierData) => [
    {
        label: 'Wooden Products',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Barrels' },
            { id: 1, value: 'Pallets' }
        ],
        selectLabel: 'Select Product'
    },
    {
        label: 'Supplier',
        field: 'supplier',
        type: 'select',
        options: generateSupplierOptions(supplierData),
        selectLabel: 'Select Supplier',

    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Items' },
        ]
    },
    {
        ...valueInputColumn,
    },
    {
        ...fileUploadColumn,
    }
]

// --- Wooden Products Totals ---

export const woodenProductsTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Total Barrels', field: 'barrelsQuantity' },
    { label: 'Total Pallets', field: 'palletsQuantity' },
]
export const woodenProductsGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Barrels', field: 'grand_total_barrels' },
    { label: 'Grand Total Pallets', field: 'grand_total_pallets' }
]
// --- Packaging Columns ---

export const packagingColumns = (supplierData) => [
    {
        label: 'Packaging',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Glass' },
            { id: 1, value: 'Cardboard' },
            { id: 2, value: 'Labels' },
            { id: 3, value: 'Corks' },
            { id: 4, value: 'Plastic' }
        ],
        selectLabel: 'Select Packaging'
    },
    {
        label: 'Supplier',
        field: 'supplier',
        type: 'select',
        options: generateSupplierOptions(supplierData),
        selectLabel: 'Select Supplier',

    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
        ]
    },
    {
        ...valueInputColumn,
    },
    {
        ...fileUploadColumn,
    }
]

// --- Packaging Totals ---

export const packagingTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Glass (kg)', field: 'glassQuantity' },
    { label: 'Cardboard (kg)', field: 'cardboardQuantity' },
    { label: 'Labels (kg)', field: 'labelsQuantity' },
    { label: 'Corks (kg)', field: 'corksQuantity' },
    { label: 'Plastic (kg)', field: 'plasticQuantity' },
]
export const packagingGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Glass', field: 'grand_total_glass' },
    { label: 'Grand Total Cardboard', field: 'grand_total_cardboard' },
    { label: 'Grand Total Labels', field: 'grand_total_labels' },
    { label: 'Grand Total Corks', field: 'grand_total_corks' },
    { label: 'Grand Total Plastic', field: 'grand_total_plastic' }
]
// --- Wine and Grapes Columns ---

export const wineAndGrapesColumns = (supplierData) => [
    {
        label: 'Wine and Grapes',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Bottled Wine' },
            { id: 1, value: 'Bulk Wine' },
            { id: 2, value: 'Bulk Grapes' }
        ],
        selectLabel: 'Select Type'
    },
    {
        label: 'Supplier',
        field: 'supplier',
        type: 'select',
        options: generateSupplierOptions(supplierData),
        selectLabel: 'Select Supplier',

    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
            { id: 1, value: 'Kilolitres' },
        ],
        disabled: true,
        selectLabel: 'Unit',
    },
    {
        ...valueInputColumn,
    },
    {
        ...fileUploadColumn,
    }
]

// --- Wine and Grapes Totals ---

export const wineAndGrapesTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Bottled Wine (kl)', field: 'bottledWineQuantity' },
    { label: 'Bulk Wine (kl)', field: 'bulkWineQuantity' },
    { label: 'Bulk Grapes (kg)', field: 'bulkGrapesQuantity' },
]
export const wineAndGrapesGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Bottled Wine', field: 'grand_total_bottled_wine' },
    { label: 'Grand Total Bulk Wine', field: 'grand_total_bulk_wine' },
    { label: 'Grand Total Bulk Grapes', field: 'grand_total_bulk_grapes' },
]
// --- Other Columns ---

export const otherColumns = (supplierData) => [
    {
        label: 'Other',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Office Paper' }
        ],
        selectLabel: 'Select Type'
    },
    {
        label: 'Supplier',
        field: 'supplier',
        type: 'select',
        options: generateSupplierOptions(supplierData),
        selectLabel: 'Select Supplier',

    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Reams' }
        ]
    },
    {
        ...valueInputColumn,
    },
    {
        ...fileUploadColumn,
    }
]

// --- Other Totals ---

export const otherTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Total (Reams)', field: 'reamsQuantity' },
]
export const otherGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Reams', field: 'grand_total' },
]

// --- Capital Goods and Services Columns ---

export const capitalGoodsAndServicesColumns = (supplierData) => [
    {
        label: 'Asset',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Buildings and facilities' },
            { id: 1, value: 'Machinery and equipment' },
            { id: 2, value: 'Vehicles' },
            { id: 3, value: 'Infrastructure' },
            { id: 4, value: 'Furniture and Fixtures' },
            { id: 5, value: 'Renewable Energy Installation' },
            { id: 6, value: 'Other' }
        ],
        selectLabel: 'Select Asset'
    },
    {
        label: 'Supplier',
        field: 'supplier',
        type: 'select',
        options: generateSupplierOptions(supplierData),
        selectLabel: 'Select Supplier',

    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Rand' }
        ]
    },
    {
        ...valueInputColumn,
    },
    {
        label: 'Description',
        field: 'description',
        type: 'text',
        placeholder: 'Enter Description'
    },
    {
        ...fileUploadColumn,
    }
]

// --- Capital Goods and Services Totals ---

export const capitalGoodsAndServicesTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Buildings and Facilities', field: 'buildingAndFacilitiesQuantity' },
    { label: 'Machinery and Equipment', field: 'machineryAndEquipmentQuantity' },
    { label: 'Vehicles', field: 'vehiclesQuantity' },
    { label: 'Infrastructure', field: 'infrastructureQuantity' },
    { label: 'Furniture and Fixtures', field: 'furnitureAndFixturesQuantity' },
    { label: 'Renewable Energy Installation', field: 'renewableEnergyInstallationQuantity' },
    { label: 'Other', field: 'otherQuantity' },
]
export const capitalGoodsAndServicesGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Buildings and Facilities', field: 'grand_total_buildings_and_facilities' },
    { label: 'Grand Total Machinery and Equipment', field: 'grand_total_machinery_and_equipment' },
    { label: 'Grand Total Vehicles', field: 'grand_total_vehicles' },
    { label: 'Grand Total Infrastructure', field: 'grand_total_infrastructure' },
    { label: 'Grand Total Furniture and Fixtures', field: 'grand_total_furniture_and_fixtures' },
    { label: 'Grand Total Renewable Energy Installation', field: 'grand_total_renewable_energy_installation' },
    { label: 'Grand Total Other', field: 'grand_total_other' },
]